import messages from './messages';
import apiMessages from './apiMessages';

export default { ...messages, ...apiMessages };
